import { render, staticRenderFns } from "./crane-machine.vue?vue&type=template&id=673d8520&scoped=true"
import script from "./crane-machine.vue?vue&type=script&lang=js"
export * from "./crane-machine.vue?vue&type=script&lang=js"
import style0 from "./crane-machine.vue?vue&type=style&index=0&id=673d8520&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d8520",
  null
  
)

export default component.exports